import { services } from '../../../../constants/services';
import { getByQuery } from '../../../../utils/api';

export class GetUsersWithPaginationService {
  async run(params: parmsRomms) {
    const response = await getByQuery<any[]>(`${services.users}/access/users/getAll`, params);
    return response;
  };
};